import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    mainWrapperObservations: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    text: {
        width: "100%",
    },
    avatar: {
        width: `27.5px !important`,
        height: `27.5px !important`,
    },
}));
